import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './ComingSoonSplash.css';

function pad(n) {
  return String(n).padStart(2, '0');
}

function diffParts(targetMs, nowMs) {
  let delta = Math.max(0, targetMs - nowMs);
  const days = Math.floor(delta / 86400000); delta -= days * 86400000;
  const hours = Math.floor(delta / 3600000); delta -= hours * 3600000;
  const minutes = Math.floor(delta / 60000); delta -= minutes * 60000;
  const seconds = Math.floor(delta / 1000);
  return { days, hours, minutes, seconds, finished: targetMs - nowMs <= 0 };
}

function ComingSoonSplash({ launchAt, skewMs = 0, onLaunched }) {
  const targetMs = Date.parse(launchAt);
  const valid = Number.isFinite(targetMs);
  const [parts, setParts] = useState(() => diffParts(valid ? targetMs : 0, Date.now() + skewMs));

  useEffect(() => {
    if (!valid) return undefined;
    let id;
    const tick = () => {
      const next = diffParts(targetMs, Date.now() + skewMs);
      setParts(next);
      if (next.finished) {
        clearInterval(id);
        if (onLaunched) onLaunched();
      }
    };
    tick();
    id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [targetMs, skewMs, onLaunched, valid]);

  if (!valid) {
    return null;
  }

  const localLaunchString = new Date(targetMs).toLocaleString(undefined, {
    weekday: 'long', year: 'numeric', month: 'long', day: 'numeric',
    hour: '2-digit', minute: '2-digit', timeZoneName: 'short',
  });

  return (
    <div className="coming-soon-splash">
      <div className="coming-soon-inner">
        <h1 className="coming-soon-headline">The Missing Wall opens soon.</h1>
        <p className="coming-soon-subline">{localLaunchString}</p>
        <div className="coming-soon-countdown" aria-label="Countdown to launch">
          <div className="countdown-cell"><span className="countdown-num">{pad(parts.days)}</span><span className="countdown-label">Days</span></div>
          <div className="countdown-sep">:</div>
          <div className="countdown-cell"><span className="countdown-num">{pad(parts.hours)}</span><span className="countdown-label">Hours</span></div>
          <div className="countdown-sep">:</div>
          <div className="countdown-cell"><span className="countdown-num">{pad(parts.minutes)}</span><span className="countdown-label">Minutes</span></div>
          <div className="countdown-sep">:</div>
          <div className="countdown-cell"><span className="countdown-num">{pad(parts.seconds)}</span><span className="countdown-label">Seconds</span></div>
        </div>
        <Link to="/login" className="coming-soon-staff-link">Staff login</Link>
      </div>
    </div>
  );
}

export default ComingSoonSplash;
